export default __webpack_public_path__ + "static/media/announcement_5@2x.b759d802.png";